import { CommonModule } from '@angular/common';
import { Component, AfterViewInit, Inject, PLATFORM_ID, OnDestroy, ViewChildren, ViewChild, ElementRef, QueryList } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
//import $ from 'jquery';

import { ActivatedRoute, RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { Subject } from 'rxjs';
import { error } from 'node:console';
import { Tooltip } from 'bootstrap';
declare var bootstrap: any;

@Component({
  selector: 'app-manager-approver-timesheet',
  standalone: true,
  imports: [CommonModule, TranslateModule, HttpClientModule, FormsModule],
  providers: [Base64UrlService],
  templateUrl: './manager-approver-timesheet.component.html',
  styleUrl: './manager-approver-timesheet.component.css'
})
export class ManagerApproverTimesheetComponent {
  @ViewChild('btnclaim_history_popup') cngButton!: ElementRef;
      @ViewChild('btntraining_history_popup') cngHistoryButton!: ElementRef;
      
        userName: any;
        lang: any;
        userCode: any;
        timeSheetTopPannel: any;
        monthDropdown: any;
        timeSheetData: any;
        timeSheetCmnData: any;
        jobOrderData: any;
        noteTypes: any;
        expensesTypes: any;
        timesheetId: any;
        timesheetIdOrg: any;
        userId: any;
        userIdOrg: any;
        editingRow: number | null = null;
        dashboard_msg: string | null = null;
        msgType: any;
        selectAll = false;
        selectedTimesheetId: number | string = '';
        isButtonDisabled: boolean = false;
        expandedRows: boolean[] = [];
        expandedRowsButton: boolean[] = [];
        thread_msg: any;
        yearList: number[] = [];
        monthList: number[] = [];
        dayList: number[] = [];
        selectedYear: number |null = null;
        selectedMonth: number | null = null;
        selectedDay: number | null = null;
        historyComments: string = '';
        historyCommentsDis: string = '';
        trainingComments: string = '';
        trainingCommentsDis: string = '';
        archive: boolean = false;
        
        dtOptions: any = {};
        dtTrigger: Subject<any> = new Subject<any>();
        constructor(private route: ActivatedRoute, private auth: AuthService,private translate: TranslateService, private pageTitle: PageTitleService, private ts: TimesheetService, private en: EncryptionService, private http: HttpClient, private router: Router,
         private safeUrl: Base64UrlService, @Inject(PLATFORM_ID) private platformId: Object
        ) { 
          if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') { 
      
            this.lang = (localStorage.getItem('site_lang')?localStorage.getItem('site_lang'): 'en');
            console.log(this.lang)
            translate.use(this.lang);
          }
        }
      
        ngOnInit() {
          this.userCode = this.auth.getCode();
          if (isPlatformBrowser(this.platformId)) {
            // this.timesheetId = this.en.decryptionAES(this.route.snapshot.params['id']);
            this.timesheetId = this.en.decryptionAES(Base64UrlService.decode(this.route.snapshot.params['id']));
            
            this.timesheetIdOrg = this.route.snapshot.params['id'];
            this.userId = this.en.decryptionAES(Base64UrlService.decode(this.route.snapshot.params['userId']));
            this.userIdOrg = this.route.snapshot.params['userId'];
            this.dashboard_msg = null;
            this.dashboard_msg = localStorage.getItem('dashboard_msg');    
            localStorage.removeItem('dashboard_msg');
            this.thread_msg = null;
          
            this.userName = this.auth.getName();
            this.pageTitle.setTitle('menu.timesheet');
            this.selectedTimesheetId = this.timesheetId;
            this.getMonthDropDown();
            this.getTimesheetData();
          }
        }
      
        @ViewChildren('tooltipEl', { read: ElementRef }) tooltipElements!: QueryList<ElementRef>;
      
        ngAfterViewInit() {
          this.initTooltips();
          this.tooltipElements.changes.subscribe(() => this.initTooltips());
        }
      
        private initTooltips(): void {
          this.tooltipElements.forEach((el) => new Tooltip(el.nativeElement));
        }
        
        triggerClick() {
          this.cngButton.nativeElement.click();
          this.cngHistoryButton.nativeElement.click();
        }
      
        getShortText(text: string, limit: number = 30): string {
          return text && text.length > limit ? text.substring(0, limit) + '...' : text;
        }
      
        getMonthDropDown() {
          // this.ts.getMonthList()
          // console.log(this.userId);
          this.ts.getMonthWithTimesheetIdNew(this.userId)
          .subscribe({
            next: (resMonthList: any) => {
              if (resMonthList.status) {
                this.monthDropdown = resMonthList.data;          
              } else {
                this.dashboard_msg = "dataRetriveErrorMessage";
                this.msgType = "danger";           
                this.isButtonDisabled = false;
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
              // console.log(this.monthDropdown);        
            },
            error: (err: any) => {        
              if (err.status == 401) {
                this.auth.logout();
            return
              } else {
                this.dashboard_msg = "dataRetriveErrorMessage";
                this.msgType = "danger";           
                this.isButtonDisabled = false;
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }
          });
        }
      
        getTimeDiffInMinutes(start: string, end: string) {    
          const startTime = new Date(start).getTime();
          const endTime = new Date(end).getTime();
          const diffMs = endTime - startTime;
          const diffMin = Math.floor(diffMs / (1000 * 60));    // convert to minutes
          let rt = this.addMinutesWithOverflow(start, diffMin).split('T')[1].split(':');
          let finalEndTime = `${parseInt(rt[0], 10)}:${rt[1]}`;
          return finalEndTime;
        }
        
        addMinutesWithOverflow(dateStr: string, minutes: number): string {
          const base = new Date(dateStr);
        
          // Add minutes normally
          const updated = new Date(base.getTime() + minutes * 60000);
        
          // Calculate total minutes since start of the day
          const diffMs = updated.getTime() - new Date(base.toDateString()).getTime();
          const totalMinutes = diffMs / 60000;
        
          const hours = Math.floor(totalMinutes / 60);
          const mins = Math.floor(totalMinutes % 60);
        
          // Format back as overflow time
          const hh = hours.toString().padStart(2, '0');
          const mm = mins.toString().padStart(2, '0');
        
          const datePart = dateStr.split("T")[0];
        
          return `${datePart}T${hh}:${mm}:00`;
        }
      
        getTimesheetData() {   
          this.ts.getTimeSheetById(this.timesheetId)
            .subscribe({
              next: (res: any) => {
                if (res.status) {
                  // console.log(res.data);
                  // this.timeSheetData = res.data;
      
                  // this.timesheetId = -2145145950;
                  this.timeSheetCmnData = res.data.timeSheet;
                  this.archive = res.data.isArchived;
                  this.historyComments = this.timeSheetCmnData.complaintComments;
                  this.historyCommentsDis = this.timeSheetCmnData.complaintComments;
                  this.trainingComments = this.timeSheetCmnData.trainingComments;
                  this.trainingCommentsDis = this.timeSheetCmnData.trainingComments;
                  this.selectedYear = this.getYearN(this.timeSheetCmnData.complaintCmtUpdateDate);
                  this.selectedMonth = this.getMonthN(this.timeSheetCmnData.complaintCmtUpdateDate);
                  this.selectedDay = this.getDayN(this.timeSheetCmnData.complaintCmtUpdateDate);
      
                  this.timeSheetData = res.data.lineItems.map((item: any) => {
                  return {
                    ...item,
                    // Convert start/finish/breaks into HH:mm for direct binding
                    startTime: (item.startTime == '1972-01-12T00:00:00') ? '' : String(this.toTimeString(item.startTime)).padStart(2, '0'),
                    startTimeOrg: item.startTime,
                    endTime: (item.endTime == '1972-01-12T00:00:00') ? '' : String(this.getTimeDiffInMinutes(item.startTime, item.endTime)).padStart(2, '0'),
                    endTimeOrg: item.endTime,
                    markedForSubmit: false,
                  };
                  });
                  this.timeSheetTopPannel = res.data.timesheetSummary[0];
                  this.jobOrderData = res.data.jobOrder;
                  // console.log(this.timeSheetData);
                  // console.log(this.toTimeString("2025-04-02T04:00:00.000Z"));
                  // console.log(this.toTimeString("2025-04-02T13:10:00.000Z"));
                  
                  this.ts.getNoteTypes()
                    .subscribe({
                      next: (resNote: any) => {
                        if (resNote.status) {
                          // console.log(resNote.data);
                          this.noteTypes = resNote.data;
                        } else {
                          this.dashboard_msg = resNote.message//"dataRetriveErrorMessage";
                          this.msgType = "danger";           
                          this.isButtonDisabled = false;
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                      },
                      error: (err: any) => {
                        console.log(err)
                        if (err.status == 401) {
                          this.auth.logout();
                          return
                        }
                        this.dashboard_msg = "dataRetriveErrorMessage";
                        this.msgType = "danger";           
                        this.isButtonDisabled = false;
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }
                    });
                  
                  this.ts.getExpensesTypes()
                    .subscribe({
                      next: (resExpenses: any) => {
                        if (resExpenses.status) {
                          // console.log(resExpenses.data);
                          this.expensesTypes = resExpenses.data;
                        } else {
                          this.dashboard_msg = resExpenses.message;//"dataRetriveErrorMessage";
                            this.msgType = "danger";           
                            this.isButtonDisabled = false;
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                      },
                      error: (err: any) => {
                        console.log(err)
                        if (err.status == 401) {
                          this.auth.logout();
                          return
                        }
                        this.dashboard_msg = "dataRetriveErrorMessage";
                        this.msgType = "danger";           
                        this.isButtonDisabled = false;
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }
                    });
                  
                  const currentYear = new Date().getFullYear();
                  this.yearList = Array.from({ length: 5 }, (_, i) => currentYear - i);
                    
                  this.monthList = Array.from({ length: 12 }, (_, i) => i + 1);
                  this.dayList = Array.from({ length: 31 }, (_, i) => i + 1);            
                  
                } else {
                  this.dashboard_msg = res.message;//"dataRetriveErrorMessage";
                  this.msgType = "danger";           
                  this.isButtonDisabled = false;
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              },
              error: (err: any) => {
                console.log(err)
                if (err.status == 401) {
                  this.auth.logout();
                  return
                }  else {
                  this.dashboard_msg = "dataRetriveErrorMessage";
                  this.msgType = "danger";           
                  this.isButtonDisabled = false;
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }
          })
        }
        getMonth(dateStr: string): string {
          const [day, month, year] = dateStr.split('-').map(Number);
          const date = new Date(year, month - 1, day);
          return date.toLocaleDateString('en-US', { month: 'short' });
        }
        getYear(dateStr: string): string {
          const [day, month, year] = dateStr.split('-').map(Number);
          const date = new Date(year, month - 1, day);
          return date.toLocaleDateString('en-US', { year: 'numeric' });
        } 
        getMonthYear(dateStr: string): string {
          const [day, month, year] = dateStr.split('-').map(Number);
          const date = new Date(year, month - 1, day);
          return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
        }
      
        getYearN(dateStr: string) {
          const date = new Date(dateStr);
          const year = date.getFullYear();    
          return year;
        }
      
        getMonthN(dateStr: string) {
          const date = new Date(dateStr);
          const month = date.getMonth()+1;
          return month;
        }
      
        getDayN(dateStr: string) {
          const date = new Date(dateStr);
          const day = date.getDate();
          return day;
        }
      ngOnDestroy(): void {
          if (isPlatformBrowser(this.platformId)) {
            const table = ($('#attendanceTable') as any).DataTable();
            if (table) {
              table.destroy(true);
            }
          }
        }
        toggleAllApprovals(event: Event) {
          const input = event.target as HTMLInputElement;
          const isChecked = input.checked;
      
          this.selectAll = isChecked; // update header state
      
          // Update all rows
          this.timeSheetData.forEach((item: any) => {
            if(item.status == 20)
              item.markedForSubmit = isChecked;
          });
      
          console.log('All Approve checkboxes set to:', isChecked);
        }
      
        onRowApproveChange() {
          this.selectAll = this.timeSheetData.every((item: any) => item.markedForSubmit);
        }
      
        chkSubmitCnt() {
          // console.log(chkStatus)
          const total = this.timeSheetData.length;
          const checked = this.timeSheetData.filter((item: any) => item.markedForSubmit).length;
          // console.log(this.timeSheetData.length);
          // console.log(this.timeSheetData.filter((item: any) => item.markedForSubmit).length);
          this.selectAll = (total > 0 && checked === total);
          
        }
        onSave(): void {
          const startTimeRegex = /^(?:0[1-9]|1\d|2[0-3]|[1-9]):[0-5]\d$/;
          let hasError = false;
          let cntApprove = 0;
          $(".timeSheet_row").each(function () { 
            const isChecked = $(this).find(".chkApproveStatus").is(":checked");
      
            if (isChecked) {
              cntApprove += 1; 
            } else {
              console.log("This row's checkbox is NOT checked");
            }
          })
          // console.log(cntApprove);
          if (cntApprove == 0) {
            hasError = true;
          }
          // stop if any error found
          // if (hasError) {
          //   // console.log("Validation failed. Please correct errors before submitting.");
          //   this.dashboard_msg = "validationApproverErrorMessage";
          //   this.msgType = "danger";
          //   return;
          // } 
          
          // Prepare payload
          // First filter the array based on the checkbox checked then map the filtrered array
          const items = this.timeSheetData.filter((item: any) => item.markedForSubmit).map((item: any) => ({
            timesheetLineItemId: item.timesheetLineItemId ?? 0,
            status: item.markedForSubmit ? 40 : item.status, 
            etcRemarks: item.etcRemarks ?? '',
            rowVersion: item.rowVersion ?? null,
          }));
      
          const comments = this.timeSheetCmnData.comments;
          const payload = {
            timesheetId: this.timesheetId,
            items,
            comments: comments
          };
      
          // console.log(payload);
          // return;
          this.ts.approveRejectTimeSheet(payload)
            .subscribe({
              next: (res: any) => {
                if (res.status) {
                  this.dashboard_msg = res.message; //"dataSaveSuccesMessage";
                  this.msgType = "success";
                  this.getTimesheetData();
                  this.isButtonDisabled = false;
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                } else {
                  this.dashboard_msg = res.message; //"dataSaveErrorMessage";
                  this.msgType = "danger";
                  this.getTimesheetData();
                  this.isButtonDisabled = false;
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              },
              error: (err: any) => {
                console.log(err);
                if (err.status == 401) { 
                  this.auth.logout();
                  return
                } else {
                  this.dashboard_msg = "dataSaveErrorMessage";
                  this.msgType = "danger";
                  this.getTimesheetData();
                  this.isButtonDisabled = false;
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }
          })
        }
      
        editReject(index: number) {
          // console.log(event);
          // const input = event.target as HTMLInputElement;
          // const isChecked = input.checked;
          // this.editingRow = index;
          if (this.timeSheetData[index].markedForReject) {      
            this.editingRow = index;
            this.archive = true;
            this.expandedRows[index] = true;
            this.expandedRowsButton[index] = true;
          } else {
            this.editingRow = null;
            this.archive = false;  
          }    
        }
      
        cancelReject(index: number) {
          // console.log("cancel reject");
          this.timeSheetData[index].markedForReject = false;
          this.editingRow = null;
          this.archive = false;
          this.selectAll = false;
          this.expandedRows[index] = false;
          this.expandedRowsButton[index] = false;
          this.getTimesheetData();
        }
        saveReject(index: number) {
          // console.log("save reject");
          this.editingRow = null;
          const item = this.timeSheetData[index];
          
          // Validate breakMinutes for this row
          // if (this.isBreakMinutesInvalid(item)) {
          //   // Optionally, set a flag or just return
          //   return;
          // }
      
          // Prepare single row payload
          const items = [{
            timesheetLineItemId: item.timesheetLineItemId ?? 0,
            // dayDate: item.dayDate ?? '',
            // startTime: this.toIsoString(item.startTime, item.startTimeOrg),
            // endTime: this.toIsoString(item.endTime, item.endTimeOrg) ?? '',
            // midnightBreakMinutes: item.midnightBreakMinutes ?? 0,
            // breakMinutes: item.breakMinutes ?? 0,
            // noteId: item.noteId ?? 0,
            // expenseId: item.expenseId ?? 0,
            status: 30,
            // cost: item.cost ?? 0,
            // whf: item.whf ?? false,
            etcRemarks: item.etcRemarks ?? '',
            rowVersion: item.rowVersion ?? null
          }];
      // timesheetId: this.timesheetId,
          const payload = {      
            items
          };
      
          // console.log(payload);
          // return false;
      
          this.ts.approveRejectTimeSheet(payload)
            .subscribe({
              next: (res: any) => {
                if (res.status) {
                  this.dashboard_msg = res.message; //"dataSaveSuccesMessage";
                  this.msgType = "success";
                  this.getTimesheetData();
                  this.isButtonDisabled = false;
                  this.archive = false;
                  this.selectAll = false;
                  this.expandedRows[index] = false;
                  this.expandedRowsButton[index] = false;
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                } else {
                  this.dashboard_msg = res.message;"dataSaveErrorMessage";
                  this.msgType = "danger";
                  this.getTimesheetData();
                  this.isButtonDisabled = false;
                  this.archive = false;
                  this.selectAll = false;
                  this.expandedRows[index] = false;
                  this.expandedRowsButton[index] = false;
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              },
              error: (err: any) => {
                console.log(err);
                if (err.status == 401) { 
                  this.auth.logout();
                  return
                } else if (err.status === 409) {
                  this.dashboard_msg = "dataConflictErrorMessage";
                  this.msgType = "danger";
                  this.ts.invalidateTimesheetDataCache(this.timesheetId);
                  this.getTimesheetData();
                  this.isButtonDisabled = false;
                  this.archive = false;
                  this.selectAll = false;
                  this.expandedRows[index] = false;
                  this.expandedRowsButton[index] = false;
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                } else {
                  this.dashboard_msg = "dataSaveErrorMessage";
                  this.msgType = "danger";
                  this.getTimesheetData();
                  this.isButtonDisabled = false;
                  this.archive = false;
                  this.selectAll = false;
                  this.expandedRows[index] = false;
                  this.expandedRowsButton[index] = false;
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }
          })
        }
        reset() {
          this.dashboard_msg = null;
        }
        /*----------- Timesheet format logic ------------*/
        getDayWeekKey(dateString: string): { day: string, weekdayKey: string, shortweekday: string } {
          const date = new Date(dateString);
          const day = date.getDate().toString().padStart(2, '0');
          const weekdayIndex = date.getDay();
      
          const weekdayKeys = [
            'WEEKDAYS.SUNDAY',
            'WEEKDAYS.MONDAY',
            'WEEKDAYS.TUESDAY',
            'WEEKDAYS.WEDNESDAY',
            'WEEKDAYS.THURSDAY',
            'WEEKDAYS.FRIDAY',
            'WEEKDAYS.SATURDAY'
          ];
      
          const weekdayKeysShort = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      
          return { day, weekdayKey: weekdayKeys[weekdayIndex], shortweekday: weekdayKeysShort[weekdayIndex] };
        }
      
        getStatus(status: number): { statusKey: string } {
          let statusIndex = 0;
          if (status == 40) {
            statusIndex = 4;
          } else if (status == 30) {
            statusIndex = 3;
          } else if (status == 20) {
            statusIndex = 1;
          } else {
            statusIndex = 0;
          }
          const statusKeys = [
            "SHORTSTATUS.NOTSUBMIT",
            "SHORTSTATUS.SUBMIT",
            "SHORTSTATUS.FIX",
            "SHORTSTATUS.REJECT",
            "SHORTSTATUS.APPROVE"
          ];
          return {statusKey: statusKeys[statusIndex]}
        }
      
        getStartTime(dateString: string): string {
          const date = new Date(dateString);
          const hours = date.getHours().toString().padStart(2, '0');
          const minutes = date.getMinutes().toString().padStart(2, '0');
          return `${hours}:${minutes}`;
        }
      
       
        toTimeString(dateString: string): string {
          if (!dateString) return '';
          const date = new Date(dateString);
          if (isNaN(date.getTime())) return '';
          const hours = date.getHours().toString();
          const minutes = date.getMinutes().toString().padStart(2, '0');
          return `${hours}:${minutes}`;
        }
      
        fncCng(event: any) {
          const target = event.target as HTMLSelectElement;
          this.timesheetId = target.value;
          this.timesheetIdOrg = Base64UrlService.encode(this.en.encryptionAES(this.timesheetId.toString()));
          this.getTimesheetData();
        }
      
        private toIsoString(time: any, originalIso: string): string {
          // console.log(time);
          if (typeof time === 'object' && time !== null) {      
            const date = new Date(time);
            const hours = date.getHours();
            const minutes = date.getMinutes();            
            time = `${String(hours)}:${String(minutes)}`;
          }
          const [hours, minutes] = time.split(':').map(Number);
          // const date = new Date(originalIso || new Date());
          // date.setHours(hours, minutes, 0);
          
          const date = new Date(originalIso || new Date());    
          // Create a new Date object with today's date and given time
          const yyyy = String(date.getFullYear());
          const mm = String(date.getMonth() + 1).padStart(2, '0');
          const dd = String(date.getDate()).padStart(2, '0');  
          const hh = String(hours).padStart(2, '0');
          const min = String(minutes).padStart(2, '0');
      
          return `${yyyy}-${mm}-${dd}T${hh}:${min}:00.000Z`;
        }
      
        
        getEndTime(dateString: string): string {
          const date = new Date(dateString);
          const hours = date.getHours().toString().padStart(2, '0');
          const minutes = date.getMinutes().toString().padStart(2, '0');
          return `${hours}:${minutes}`;
        }
      
        getNote(note: number): { noteKey: string } {
          let statusIndex = 0;
          if (note == 10) {
            statusIndex = 0;
          } else if (note == 20) {
            statusIndex = 1;
          } else if (note == 40) {
            statusIndex = 2;
          } else if (note == 50) {
            statusIndex = 3;
          } else {
            statusIndex = 4;
          }
          const noteKeys = [
            "",
            "NOTEDD.PaidLeave",
            "NOTEDD.Tardiness",
            "NOTEDD.Absence",
            "NOTEDD.SeeComment"
          ];
          return {noteKey: noteKeys[statusIndex]}
        }
        
        getExpenses(expenses: number): { expensesKey: string } {
          let statusIndex = 0;
          if (expenses == 0) {
            statusIndex = 0;
          } else if (expenses == 1) {
            statusIndex = 1;
          } else if (expenses == 2) {
            statusIndex = 2;
          }
          const expensesKeys = [
            "",
            "ExpenseDD.AdvancePayment",
            "ExpenseDD.Transportation"
          ];
          return {expensesKey: expensesKeys[statusIndex]}
        }
      
        getClass(status: number): string {
          if(status == 10){
            return 'tr_non_submit';
          } else if(status == 20){
            return 'tr_submit';
          } else if(status == 30){
            return 'tr_reject';
          } else {
            return 'tr_approve';
          }
          
        }
      
        isBreakMinutesInvalid(item: any): boolean {
          return (
            item.breakMinutes === '' ||
            item.breakMinutes === null ||
            isNaN(item.breakMinutes) ||
            String(item.breakMinutes).trim() === ''
          );
        }
      
        toggleBelowRows(index: number): void {
          console.log(index);
          this.expandedRows[index] = !this.expandedRows[index];
          this.expandedRowsButton[index] = !this.expandedRowsButton[index];
        }
      
        onRejectClick(item: any): void {
          if (item.status === 30 || item.status === 20) {      
            // console.log(this.lang + " - - " + );item.timesheetLineItemId
            this.ts.getEtcThread(item.timesheetLineItemId, this.lang )
            .subscribe({
              next: (res: any) => {
                  this.thread_msg = res;
                  // console.log(this.thread_msg);
                },
                error: (err: any) => {
                  console.log(err)
                  if(err.status == 401){
                    this.auth.logout()
              return
                  }
                }
            })
      
          }
        }
      
        threadClose() {
          this.thread_msg = null;
        }
      
        formatDateTime(dateString: string): string {
          const date = new Date(dateString);
      
          const year = date.getFullYear();
          const month = date.toLocaleString('en-US', { month: 'short' }); // "Oct"
          const day = date.getDate().toString().padStart(2, '0');
      
          const hours = date.getHours().toString().padStart(2, '0');
          const minutes = date.getMinutes().toString().padStart(2, '0');
      
          return `${year}-${month}-${day} : ${hours}:${minutes}`;
        }
        
        formatClaimDate(dateString: string): string {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = (date.getMonth()+1).toString().padStart(2, '0'); // "Oct"
          const day = date.getDate().toString().padStart(2, '0');
      
          return `${year}-${month}-${day}`;
        }
      
      
        dwnPdf(id: any) {
          this.ts.getPdf(id )
            .subscribe({
              next: (res: any) => {
                  const blob = new Blob([res.body ?? res], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(blob);
            window.open(fileURL);
                },
                error: (err: any) => {
                  console.log(err)
            if (err.status == 401) {
              this.auth.logout();
              return
            }
                }
            })
        }
      
        saveHistory() {    
      
      //     let year = this.selectedYear;
      //     let month = String(this.selectedMonth).padStart(2, '0');
      //     let day = String(this.selectedDay).padStart(2, '0');
          
      //     let updateDate = `${year}-${month}-${day}T00:00:00.000Z`;
      // ,
      //       "complaintCmtUpdateDate": updateDate
          const payLoad =
          {
            "timesheetId": this.timesheetId,
            "complaintComments": this.historyComments
          }
          // const modalElement: any = document.getElementById('claim_history_popup');
          // if (!modalElement) return;
          // const modalInstance = bootstrap.Modal.getInstance(modalElement)
            // || new bootstrap.Modal(modalElement);   
          // const modalInstance = (bootstrap.Modal.getOrCreateInstance);
            // ? bootstrap.Modal.getOrCreateInstance(modalElement)
            // : (bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement));
          // console.log(payLoad)
          // return;
          this.ts.updateClaimHistory(payLoad)
            .subscribe({
              next: (res: any) => {
                if (res.status) {
                  
                  // modalElement.addEventListener(
                  //     'hidden.bs.modal',
                  //     () => {
                  //       bootstrap.Modal.getInstance(modalElement)?.dispose();
                  //       this.getTimesheetData();          // SAFE HERE
                  //     },
                  //     { once: true }
                  //   );
      
                  //   modalInstance?.hide(); 
                  // modalInstance?.hide();
                  // modalElement.addEventListener('hidden.bs.modal', () => {
                  //   // this.getTimesheetData();
                  //   try { modalInstance.dispose(); } catch(e) {}
                  // }, { once: true });
                  // modalElement.addEventListener('hidden.bs.modal', () => {
                  //   this.getTimesheetData();
                  //   bootstrap.Modal.getInstance(modalElement)?.dispose();
                  // }, { once: true });
                  // modalInstance?.hide();
                  // setTimeout(() => {
                  //   // document.body.classList.remove('modal-open');
                  //   document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                  //   try { bootstrap.Modal.getInstance(modalElement)?.dispose(); } catch(e) {}
                  // }, 300);
                  // $("#btnclaim_history_popup").click();
                  // document.getElementById('btnclaim_history_popup')?.click();
                  this.triggerClick();
                  this.getTimesheetData();
                } else {
                  alert(res.message);
                }
              },
              error: (err: any) => {
                console.log(err.message)
                if (err.status == 401) {
                  this.auth.logout()
            return
                }
              }
          })
        }
      
        saveTraining() {    
          const now = new Date();
          const updateDate = now.toISOString();
          
          const payLoad =
          {
            "timesheetId": this.timesheetId,
            "trainingComments": this.trainingComments,
            "trainingCmtUpdateDate": updateDate
          }
          const modalElement = document.getElementById('training_history_popup');
          const modalInstance = bootstrap.Modal.getInstance(modalElement) 
            || new bootstrap.Modal(modalElement);
          
          this.ts.updateTrainingHistory(payLoad)
            .subscribe({
              next: (res: any) => {
                if (res.status) {
                  // modalInstance.hide();
                  // document.getElementById("btntraining_history_popup")?.click();
                  // $("#btntraining_history_popup").click();
                  this.triggerClick();
                  this.getTimesheetData();
                  // setTimeout(() => {
                  //   document.body.classList.remove('modal-open');
                  //   document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                  // }, 300);
                } else {
                  alert(res.message);
                }
              },
              error: (err: any) => {
                console.log(err.message)
                if (err.status == 401) {
                  this.auth.logout()
            return
                }
              }
          })
        }
}
